export { default } from './ShaojiangImage';
